var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIndicatorsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448 0 51.92 14.974 66.895 33.448 66.895c8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156z",
    transform: "translate(-143 -265) translate(143 265)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M47.15 35.75c-.298-2.488-1.26-4.754-2.686-6.646l2.371-2.42c2.007 2.523 3.333 5.64 3.665 9.065h-3.35zm-5.024-9.048c-1.841-1.465-4.047-2.454-6.468-2.76V20.5c3.333.34 6.368 1.704 8.822 3.765l-2.354 2.437zm-9.784-2.76c-2.421.306-4.627 1.295-6.451 2.76l-2.371-2.437c2.454-2.061 5.489-3.424 8.822-3.765v3.442zm7.425 5.972L36.081 36.4l-.216.38.034.437c.093 1.187-.286 2.322-1.074 3.123-1.498 1.545-3.961 1.545-5.453.007-1.512-1.55-1.512-4.083-.003-5.63.898-.923 2.18-1.304 3.45-1.056l.509.1 6.44-3.847zm-18.602-3.23l2.371 2.42c-1.426 1.892-2.388 4.158-2.686 6.645H17.5c.332-3.407 1.658-6.542 3.665-9.064z",
    transform: "translate(-143 -265) translate(143 265)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIndicatorsEmpty);
export default __webpack_public_path__ + "static/media/ic_indicators_empty.47701d9d8ebb67c9c3ceb82b1decb14a.svg";
export { ForwardRef as ReactComponent };